import type { Node as PMNode, Schema } from '@atlaskit/editor-prosemirror/model';

import { getText } from '../../utils';
import { reduce } from './';
import type { NodeReducer } from './';

const unknown: NodeReducer = (node: PMNode, schema: Schema) => {
	const result: string[] = [];

	node.forEach((n) => {
		result.push(reduce(n, schema));
	});

	if (result.length > 0) {
		return result.join('');
	}
	return getText(node);
};

export default unknown;
